import { render, staticRenderFns } from "./SlackTemplatesPage.vue?vue&type=template&id=13064a56&"
import script from "./SlackTemplatesPage.vue?vue&type=script&lang=js&"
export * from "./SlackTemplatesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports